import { createContext, useContext } from 'react';
export const AppInstallerPropsContext = /*#__PURE__*/createContext({});
export const useAppInstallerPropsContext = () => useContext(AppInstallerPropsContext);
//# sourceMappingURL=AppInstallerPropsContext.js.map